import { FilterState } from '@paradigm/features/src/leaderboard/contexts/filter-provider-factory';
import MyFirm from '#/components/Leaderboard/MyFirm';
import LeaderbordFilterButton from './LeaderbordFilterButton';
import { DividerMobile, LeaderboardFiltersSectionMobile } from './components';

interface Props {
  readonly filterState: FilterState;
}

export default function MobileTabHeader({ filterState }: Props) {
  return (
    <>
      <DividerMobile />
      <LeaderboardFiltersSectionMobile>
        <LeaderbordFilterButton filterState={filterState} />
        <MyFirm />
      </LeaderboardFiltersSectionMobile>
    </>
  );
}
